module.exports = __webpack_public_path__ + "img/motivation.f35ee905.svg";